import {
  GET_ACCESSIBLE_RESOURCES,
  CHANGED_FILTER_ON_RESOURCES,
  RESET_ACCESSIBLE_RESOURCES_DATA
} from './accessible-action-types'
import {
  RESET_ACCESSIBLE_RESOURCES,
  SET_ACCESSIBLE_RESOURCES,
  SET_FILTERED_RESOURCE_BY_WEEKS
} from './accessible-mutation-types'
import * as axios from 'axios'

const state = {
  allResources: [],
  resources: []
}

const mutations = {
  [SET_ACCESSIBLE_RESOURCES] (state, resources) {
    state.resources = resources
    state.allResources = resources
  },
  [SET_FILTERED_RESOURCE_BY_WEEKS] (state, filter) {
    if (filter === 'TEN_WEEKS') {
      state.resources = state.allResources
    } else if (filter === 'FOUR_WEEKS') {
      state.resources = filterResourcesByWeeks(4)
    } else if (filter === 'ONE_WEEK') {
      state.resources = filterResourcesByWeeks(1)
    }
  },
  [RESET_ACCESSIBLE_RESOURCES] (state) {
    state.allResources = []
    state.resources = []
  }
}

function filterResourcesByWeeks (filter) {
  const today = new Date()
  const selectedDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (7 * filter))
  const filtered = state.allResources.filter((item) => {
    const date = new Date(item.weekEndDate)
    return date >= selectedDate
  })
  return filtered
}

function loadHistory (rootState, state, studentId, actionData) {
  return axios({
    url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/${studentId}/accessible_resource_usage`,
    method: 'get',
    headers: {
      'Authorization': rootState.profile.loginToken
    },
    actionData
  })
}

const actions = {
  [GET_ACCESSIBLE_RESOURCES] ({rootState, commit}, studentId) {
    const actionData = { action: 'GET_ACCESSIBLE_RESOURCES', data: studentId }
    loadHistory(rootState, state, studentId, actionData)
      .then((res) => {
        const rxs = res.data.map((item) => {
          return {
            week: item.week,
            resource: item.resourceIdentifier,
            usage: item.totalCountPerWeek,
            weekStartDate: item.weekStartDate,
            weekEndDate: item.weekEndDate
          }
        })
        commit(SET_ACCESSIBLE_RESOURCES, rxs)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [CHANGED_FILTER_ON_RESOURCES] ({rootState, commit}, filter) {
    commit(SET_FILTERED_RESOURCE_BY_WEEKS, filter)
  },
  [RESET_ACCESSIBLE_RESOURCES_DATA] ({commit}) {
    commit(RESET_ACCESSIBLE_RESOURCES)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accessibility/accessibleResources.js